export default __webpack_public_path__ + "static/feature_01-fe49227638665debba7ef3789070a630.png";